import { __assign, __awaiter, __generator, __spreadArrays } from "tslib";
import { feature, bbox } from 'topojson-client';
// eslint-disable-next-line
import { featureFactory, moduleExtract } from '../utils';
import centroids, { notSupportList as centroids_alpha2 } from './centroids';
function loadGeo() {
    return __awaiter(this, void 0, void 0, function () {
        var tjson, data, box, halfHeight, radius, wipo, epo;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, import('./topojson-world-map.json').then(moduleExtract)];
                case 1:
                    tjson = _a.sent();
                    data = __assign({}, feature(tjson, 'data'));
                    box = bbox(tjson);
                    halfHeight = box[3];
                    radius = 15;
                    wipo = featureFactory('WO', { name: 'WO', fullname: 'WIPO' }, { x: -(radius + 5), y: -halfHeight + radius + 15 }, radius, 500);
                    epo = featureFactory('EP', { name: 'EP', fullname: 'EPO' }, { x: radius + 5, y: -halfHeight + radius + 15 }, radius, 500);
                    // @ts-ignore
                    data.features = __spreadArrays(data.features, [wipo, epo]);
                    data.features.forEach(function (feature) {
                        var alpha2_name = feature.properties.name;
                        var alpha3_name = feature.properties.ISO_3_CODE;
                        // centroid point
                        var cp = centroids[alpha3_name] || centroids_alpha2[alpha2_name];
                        if (cp) {
                            feature.properties.cp = cp;
                        }
                    });
                    return [2 /*return*/, data];
            }
        });
    });
}
// eslint-disable-next-line import/prefer-default-export
export { loadGeo };
//# sourceMappingURL=loadGeo.js.map